// extracted by mini-css-extract-plugin
export default {"host":"ConfirmDelete_host__ZAX+j","buttonsPanel":"ConfirmDelete_buttonsPanel__bC2-u","deleteButton":"ConfirmDelete_deleteButton__LlR20"};